<template>
    <ds-modal
        show-close
        is-open
        :title="$t('unlayerBuilder.saveAsTemplate.modal.title')"
        @close="$emit('close')"
    >
        <save-as-template-form
            :editor="editor"
            :funnel-id="funnelId"
            :template-id="templateId"
            @saved="$emit('close')"
        />
    </ds-modal>
</template>

<script>
import SaveAsTemplateForm from './SaveAsTemplateForm';

export default {
    components: {
        SaveAsTemplateForm,
    },

    props: {
        editor: Object,
        funnelId: String,
        templateId: String,
    },

    data() {
        return {
            saveAsTemplate: '',
        };
    },
};
</script>
